'use client';

import { FC, PropsWithChildren } from 'react';
import { ROOT_PORTALS } from 'constants/targets';
import { Portal, Drawer } from 'components/pcc-components';
import { useMyEquipmentDrawer } from '../my-equipment-drawer-context';

export const SelectedEquipmentDrawerWrapper: FC<PropsWithChildren> = ({
  children,
}) => {
  const { selectedEquipmentDrawer } = useMyEquipmentDrawer();

  return (
    <Portal id={ROOT_PORTALS}>
      <Drawer {...selectedEquipmentDrawer.drawerProps}>{children}</Drawer>
    </Portal>
  );
};
